export const menus = [
    {
        title: 'AIH',
        index: 1,
        gap: true
    },
    {
        title: 'Perfil',
        index: 2
    },
    {
        title: 'UTI e UI',
        index: 3
    },
    {
        title: 'Internação',
        index: 4
    },
    {
        title: 'Faturamento',
        index: 5
    },
    {
        title: 'Procedimentos',
        index: 6
    },
    {
        title: 'Altas',
        index: 7
    }
];
